import { render, staticRenderFns } from "./SerialNumberManagement.vue?vue&type=template&id=03153dc8&"
import script from "./SerialNumberManagement.vue?vue&type=script&lang=ts&"
export * from "./SerialNumberManagement.vue?vue&type=script&lang=ts&"
import style0 from "./SerialNumberManagement.vue?vue&type=style&index=0&id=03153dc8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports